import type { EventType } from '@/app/types/analytics';

export class Analytics {
  static trackEvent(eventName: EventType, properties?: Record<string, any>) {
    window.analytics?.track?.({
      event: eventName,
      properties,
    });
  }
}
